<template>
  <b-modal hide-footer :title="'Configurar ' + formType" id="integrationConfig" size="md">

        <b-overlay :show="loading" >
            <div v-if="status != null && showForm == false">
                <div class="d-flex justify-content-between mb-3">

                    <span>Status da Integração</span>
                    <span class="text-success" v-if="status == 1">Sucesso</span>
                    <span class="text-danger" v-if="status == 0">Falha</span>


                </div>
                <button class="btn btn-primary mt-3" @click="showForm = true">Atualizar</button>
            </div>
            <form @submit.stop.prevent @submit="submit" v-if="status == null || showForm">
                <div v-if="formType === 'hotmart'">

                    <b-form-group label="ID de cliente">
                        <b-form-input
                            required
                            v-model="form.client_id"
                            type="text"
                            placeholder="Digite a id de cliente"
                        ></b-form-input>
                    </b-form-group>
    
                    <b-form-group label="Chave secreta de cliente">
                        <b-form-input
                            required
                            v-model="form.client_secret"
                            type="text"
                            placeholder="Digite a Chave secreta de cliente"
                        ></b-form-input>
                    </b-form-group>
    
                    <b-form-group label="Chave básica">
                        <b-form-input
                            required
                            v-model="form.token_basic"
                            type="text"
                            placeholder="Digite a Chave básica"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div v-if="formType === 'stripe'">
                    <b-form-group label="Webhook Token">
                        <b-form-input
                            required
                            v-model="form.webhook_token"
                            type="text"
                            placeholder="Digite o token"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <button class="btn btn-primary" type="submit">Salvar</button>
            </form>
        </b-overlay>
  </b-modal>
</template>

<script>
export default {
    props: ['formType'],
    data(){
        return {
            loading: false,
            form: {
                client_id: '',
                client_secret: '',
                token_basic: '',
                token: null,
                webhook_token: null,

            },
            showForm: false,
            status: null
        }
    },
    created(){

        this.$root.$on('integrationConfig', ()=>{
            this.$bvModal.show('integrationConfig')
        })

    },
    watch: {
        formType(){
            this.load();
        }
    },
    methods: {
        load() {
            if(this.formType === 'hotmart'){

                this.loading = true;
                axios.get(`/teacher/${this.formType}/status`)
                .then((result) => {
                    this.status = result.data.data.status
                }).catch((err) => {
    
                })
                .finally(()=> this.loading = false);
            }
        },
        submit(){
            this.loading = true
            axios.post(`/teacher/integration/`, {
                type: this.formType,
                client_id: this.form.client_id,
                client_secret: this.form.client_secret,
                token_basic: this.form.token_basic,
                webhook_token: this.form.webhook_token,
                type: this.formType,

            })
            .then((result) => {
                this.$toast.success('Salvo com sucesso');
                this.$bvModal.hide('integrationConfig')

            }).catch((err) => {

            })
            .finally(()=> this.loading = false);
        },

        showProducts(){
            this.loading = true;
            axios.get(`/teacher/${this.formType}/products`)
            .then((result) => {
                this.$toast.success('Sucesso na integração')
                //this.$bvModal.hide('integrationConfig');
                this.load()
            }).catch((err) => {
                this.$toast.error('Erro na integração')
            })
            .finally(() => this.loading =false);
        }
    }
}
</script>

<style>

</style>
